import React from "react"
import Textbox from "../input/Textbox"
import { useTranslation } from "react-i18next"

const Website = ({ required = true }) => {
  const { t, i18n } = useTranslation("forms")

  const requiredError = i18n.exists("forms:inputs.website.errors.required") ? t("inputs.website.errors.required") : t("inputsGenerics.requiredError")

  return <Textbox
    label={t("inputs.website.label")}
    name="0-2/website"
    required={required ? requiredError : false} />
}

export default Website